<template>
    <div>
        <header-page
                @goToFilteredArticlePage="goToFilteredArticlePage"
        ></header-page>
        <div
                v-if="rubrics && articles"
                class="body_zone p-t-16 p-r-20 p-b-32 p-l-20 separator-t-g2"
        >
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-10 col-xl-8 col-xxl-8">
                    <ul
                        v-if="filtered_articles.length"
                        class="list-group list-group-flush">
                        <router-link
                                v-for="article in filtered_articles"
                                :key="article.id"
                                :to="`article?r=${article.rubric_id}&a=${article.id}`"
                                custom v-slot="{ navigate }"
                        >
                            <div
                                    class="list-group-item list-group-item-action"
                                    @click="navigate"
                            >
                                <div class="card-body style_cursor">
                                    <div class="card-text css_StyleText21 d-flex justify-content-between">
                                        <div>{{article.title}}</div>
                                        <div>{{LS(article.rubric_name)}}</div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </ul>
                    <div v-else class="css_StyleText3">
                      {{LS("По-вашему запросу ничего не найдено")}}
                    </div>
                </div>
            </div>
        </div>
        <footer-page />
    </div>
</template>

<script>

import { ref, computed } from 'vue'
import {useRoute/*, useRouter*/} from 'vue-router'
import { storeToRefs } from 'pinia'

import HeaderPage from "../../shared/components/HeaderPage";
import FooterPage from "../../shared/components/FooterPage";
import {useRubricArticleStore} from "../../stores/store";
import {InitStates} from "../../shared/services/init";
import {getFilteredArticles} from "../../shared/services/util";
import {LS} from "@/shared/services/translate";

export default {
    props: {},
    setup() {
        const route = useRoute();

        InitStates();

        //console.log('FilteredArticlesPage');

        const rubricArticleStore = useRubricArticleStore();
        const { rubrics, articles } = storeToRefs(rubricArticleStore);

        const filter_text = ref(route.params.filter_text ?? '');

        const goToFilteredArticlePage = (new_filter_text) => {
            filter_text.value = new_filter_text;
        }

        const filtered_articles = computed(() => {
            return getFilteredArticles(rubrics.value, articles.value, filter_text.value);
        });

        return {
            rubrics,
            articles,
            filtered_articles,
            goToFilteredArticlePage,
            LS
        }
    },
    components: {HeaderPage, FooterPage}
}
</script>

<style scoped>
  .body_zone, .list-group-item{
    background-color: #f8faff;
  }
</style>